import React, { FC, useCallback, useRef, useState } from "react";
import GoBack from "../../../../../assets/verification/BackWhite.svg";
import IconCamera from "../../../../../assets/verification/CameraWhite.svg";
import { Camera } from "./react-camera-pro";
import SwitchCamera from "../../../../../assets/SwitchCamera.png";
import "./style.scss";
import { b64toBlob } from "helpers/functions";
import { useTranslation } from "react-i18next";
import { DocumentType } from "static/types";
import { PATH_LIST } from "shared/lib/react-router";
import { useNavigate } from "react-router-dom";

type PropType = {
  onOpen: any;
  onClose: any;
  type: DocumentType;
  className?: string;
};
export type FacingMode = "user" | "environment";
export type AspectRatio = "cover" | number;

const TakePhotoModal: FC<PropType> = ({ onOpen, onClose, type, className }) => {
  const camera = useRef(null);
  // const [devices, setDevices] = useState<MediaDeviceInfo[]>([]);
  // const [deviceId, setDeviceId] = useState<string | undefined>(undefined);

  const [numberDevices, setNumberDevices] = useState<number>(0);

  type FacingType = "front" | "back";
  const facingMode: Record<typeof type, FacingType> = {
    [DocumentType.Passport]: "back",
    [DocumentType.IdCard]: "back",
    [DocumentType.IdCardBack]: "back",
    [DocumentType.ProofAddress]: "back",
    [DocumentType.Selfie]: "front",
    [DocumentType.UtilityBill]: "back",
    [DocumentType.Avatar]: "front",
  };
  const { t: on } = useTranslation("onboarding-auth");
  const { t } = useTranslation("app");
  const cameraBoxClass: Record<typeof type, string> = {
    [DocumentType.Passport]: "",
    [DocumentType.IdCard]: "cameraBoxShort",
    [DocumentType.IdCardBack]: "cameraBoxShort",
    [DocumentType.ProofAddress]: "",
    [DocumentType.Selfie]: "",
    [DocumentType.UtilityBill]: "",
    [DocumentType.Avatar]: "",
  };
  const cameraBtnClass: Record<typeof type, string> = {
    [DocumentType.Passport]: "cameraBtn",
    [DocumentType.IdCard]: "",
    [DocumentType.IdCardBack]: "",
    [DocumentType.ProofAddress]: "cameraBtn",
    [DocumentType.Selfie]: "cameraBtn",
    [DocumentType.UtilityBill]: "cameraBtn",
    [DocumentType.Avatar]: "cameraBtn",
  };
  const firstLineText: Record<typeof type, string> = {
    [DocumentType.Passport]: "",
    [DocumentType.IdCard]: on("frontIDCard"),
    [DocumentType.IdCardBack]: on("backIDCard"),
    [DocumentType.ProofAddress]: "",
    [DocumentType.Selfie]: "",
    [DocumentType.UtilityBill]: "",
    [DocumentType.Avatar]: "",
  };

  const secondLineText: Record<typeof type, string> = {
    [DocumentType.Passport]: on("alignPassportFrameCaptureLong"),
    [DocumentType.IdCard]: on("positionFrontIDCardFrame"),
    [DocumentType.IdCardBack]: on("positionBackIDCardFrame"),
    [DocumentType.ProofAddress]: on("alignDocumentFrameCaptureDescription"),
    [DocumentType.Selfie]: on("focusCameraFacePassportID"),
    [DocumentType.UtilityBill]: on("alignDocumentFrameCaptureDescription"),
    [DocumentType.Avatar]: t("takePhoto"),
  };

  const onPhoto = useCallback(() => {
    if (camera && camera.current) {
      try {
        // @ts-ignore
        // const imageSrc = camera.current.getScreenshot();
        // const blob = b64toBlob(imageSrc, "image/jpeg");
        // blob && onOpen(blob);
        // @ts-ignore
        const imageSrc = camera.current.takePhoto();
        const blob = b64toBlob(imageSrc, "image/jpeg");
        blob && onOpen(blob);
      } catch (error) {}
    }
  }, [camera, onOpen]);

  const onChangeCamera = useCallback(() => {
    if (camera.current) {
      // @ts-ignore
      const result = camera.current.switchCamera();
      console.log(result);
    }
  }, [camera]);

  const navigate = useNavigate();

  return (
    <div className={`takePhotoType ${className}`}>
      <button className="goBack" onClick={onClose}>
        <img src={GoBack} alt="Go Back" />
      </button>

      <div onClick={() => navigate(PATH_LIST.support)} className="camera-access-failed">
        <p dangerouslySetInnerHTML={{ __html: t("cameraAccessIssueText") }} />
      </div>

      <div className={`${cameraBoxClass[type]} cameraBox`}>
        <div className="videoCover">
          <Camera
            ref={camera}
            aspectRatio="cover"
            facingMode={facingMode[type] === "front" ? "user" : "environment"}
            focusMode="continuous"
            autoFocus={true}
            numberOfCamerasCallback={(i) => setNumberDevices(i)}
            errorMessages={{
              noCameraAccessible:
                "No camera device accessible. Please connect your camera or try a different browser.",
              permissionDenied:
                "Permission denied. Please refresh and give camera permission.",
              switchCamera:
                "It is not possible to switch camera to different one because there is only one video device accessible.",
              canvas: "Canvas is not supported.",
            }}
          />
        </div>

        <div className="textTPM">
          {type !== DocumentType.Passport && <p>{firstLineText[type]}</p>}
          <span>{secondLineText[type]}</span>
        </div>
      </div>

      <div
        className="cameraBtns"
        style={{
          marginLeft: numberDevices > 1 ? "90px" : "0",
        }}
      >
        <button
          onClick={onPhoto}
          className={`${cameraBtnClass[type]} takePhotoBtn`}
        >
          <img src={IconCamera} alt="DocumentExample" />
        </button>
        {numberDevices > 1 && (
          <button
            onClick={onChangeCamera}
            className={`takePhotoBtn switchCamera`}
          >
            <img src={SwitchCamera} alt="SwitchCamera" />
          </button>
        )}
      </div>
    </div>
  );
};

export default TakePhotoModal;
